/** 問題答覆 - 結案狀態 */
export enum ServiceStatus {
  /** 已結案 */
  CLOSED = 'closed',
  /** 未結案 */
  OPENED = 'opened',
  UNPROCESS = 'unprocess',
  PROCESSING = 'processing',
  REPLIED = 'replied'
}
